/** Client-side Activity keyword match (actor, project, title, excerpt). */

export function activityEventMatchesQuery(
  query: string,
  event: {
    actor_name?: string | null
    title?: string | null
    excerpt?: string | null
    projectName?: string | null
  },
): boolean {
  const needle = query.trim().toLowerCase()
  if (!needle) return true
  const hay = [
    event.actor_name,
    event.projectName,
    event.title,
    event.excerpt,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
  return hay.includes(needle)
}
